<template>
  <div class="link-item">
    <div class="link-item__image" @click="onUrlOpen">
      <component :class="{'link-item__image_placeholder': !image, 'link-item__image_outer': image}"
               :is="image ? 'img' : 'base-material-design-icon'"
               :src="image" :alt="description"
               icon="linkVariant" ></component>
    </div>
    <div class="link-item__description" @click="onUrlOpen">{{description}}</div>
    <div class="link-item__domain">{{domain}}</div>
    <div class="link-item__time">{{date | formattedDate}}</div>
    <div class="link-item__footer">
      <a :href="url" class="link-item__url-wrapper" target="_blank">
        <base-truncate-label :label="url" :shrink="0.85" watch-class="link-item__url-wrapper"/>
      </a>
      <base-material-design-icon class="link-item__footer-link"
                                 icon="linkBox" @click="onUrlOpen"/>
      <router-link :to="`/content-briefs/${contentBriefId}/${isPublished ? 'progress' : 'strategy'}`"
                   class="link-item__footer-file" target="_blank">
        <base-material-design-icon class=""
                                   icon="file"/>
      </router-link>
    </div>

  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
import LinkProgressBar from './LinkProgressBar'
import LinkThreeColorScale from './LinkThreeColorScale'
import _ from 'lodash'
import filters from '@/common/Filters'
import LinkBuilding from './LinkBuilding'
/**
 * Grid element for {@link LinkBuilding}
 */
export default {
  name: 'LinkBuildingItem',
  components: { LinkThreeColorScale, LinkProgressBar },
  props: ['link'],
  data () {
    return {
      // tooltip options for components
      tooltipOptions: {
        trigger: 'hover',
        delay: { show: 100, hide: 500 },
        // this class changes appearance of tooltip
        classes: 'rfx-tooltip-arrow'
      }
    }
  },
  computed: {
    image () {
      return _.get(this.link, 'image_url')
    },
    domain () {
      return _.get(this.link, 'domain')
    },
    description () {
      return _.get(this.link, 'description')
    },
    date () {
      return _.get(this.link, 'target_date')
    },
    /**
     * set angle for arrow in speedometer
     * has only 3 position - right, left and top
     * @returns {number}
     */
    ratio () {
      const ratio = _.get(this.link, 'tf_ratio')
      let degree = 0
      if (ratio < 0.4) {
        degree = -75
      }
      if (ratio > 2) {
        degree = 75
      }
      return degree
    },
    flow () {
      return _.get(this.link, 'trust_flow')
    },
    footerName () {
      const domainAuthority = _.get(this.link, 'domain_authority')
      return domainAuthority ? `DA: ${domainAuthority}` : ''
    },
    publishUrl () {
      return _.get(this.link, 'link_url')
    },
    url () {
      return _.get(this.link, 'url.name')
    },
    contentBriefId () {
      return _.get(this.link, 'content_brief_id')
    },
    isPublished () {
      return _.get(this.link, 'status.label', '').toLowerCase() === 'published'
    }
  },
  methods: {
    onUrlOpen () {
      if (!this.publishUrl) {
        return
      }
      window.open(this.publishUrl, '_blank')
    }

  },
  filters: {
    ...filters
  }

}
</script>

<style scoped lang="scss">
  .subtitle {
    color: $rfx-medium-march;
    font-size: 12px;
  }
  .link-item {
    display: grid;
    grid-template-rows: 1fr 46px 32px 38px;
    grid-auto-columns: 1fr 100px;
    grid-template-areas: "image image" "description description" "domain time" "footer footer";
    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
    width: 100%;
    height: 300px;
    &__url-wrapper{
      width: 100%;
    }

    &__image {
      border-bottom: 1px solid $rfx-light-steel;
      grid-area: image;
      display: flex;
      justify-content: center;
      height: 180px;
      cursor: pointer;

      &_outer {
        width: 100%;
        border-radius: 4px 4px 0 0 ;
      }

      &_placeholder {
        justify-self: center;
        font-size: 4em;
        color: $rfx-medium-grey;
        grid-area: image;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &__description {
      grid-area: description;
      padding: 10px;
      color: $rfx-dark-march;
      cursor: pointer;

    }

    &__domain {
      color: $rfx-medium-march;
    font-size: 12px;
      grid-area: domain;
      padding: 10px;
    }

    &__time {
      color: $rfx-light-march;
      font-size: 12px;
      grid-area: time;
      padding: 10px;
    }

    &__footer {
      grid-area: footer;
      display: grid;
      grid-template-columns: 1fr 25px 40px;
      border-top: 1px solid $rfx-light-steel;
      padding: 10px;
      align-items: center;

      &-name {
        color: $rfx-dark-march;
        font-size: 12px;
      }

      &-progress {
      }

      &-flow {
        width: fit-content;
        justify-self: center;
      }

      &-link {
        cursor: pointer;
        font-size: 20px;
        justify-self: end;
      }

      &-file {
        cursor: pointer;
        font-size: 20px;
        justify-self: end;
        display: grid;
    color: $rfx-dark-march;
      }
    }
  }

</style>
